import { Button } from "neetoui";
import PropTypes from "prop-types";

import "./menubar.scss";

const SubTitle = ({ children, iconProps, ...otherProps }) => (
  <div
    className="neeto-molecules-menubar__subtitle"
    data-testid={otherProps["data-testid"] || "menubar-subtitle-heading"}
    {...otherProps}
  >
    {children}
    <div className="neeto-molecules-menubar__subtitle-actions">
      {iconProps?.map((iconProp, index) => (
        <Button key={index} style="text" {...iconProp} />
      ))}
    </div>
  </div>
);

SubTitle.propTypes = {
  /**
   * To specify the content to be rendered as the SubTitle.
   */
  children: PropTypes.node,
  /**
   * To specify the icon properties.
   */
  iconProps: PropTypes.array,
};

export default SubTitle;
